module.exports = __webpack_public_path__ + "img/Community.769e2b9f.jpeg";